"use strict";

angular.module("customer")
.directive("mainLayout", [function() {
    return {
        templateUrl: require("./layout.html"),
        controller: MainLayoutController
    };
}]);

function MainLayoutController($rootScope) {
    $rootScope.ForceUpdateCartItemCount = function(offset) {
        if (offset) {
            $rootScope.CurrentNumbers.CartItems += offset;
            $rootScope.$broadcast("OrdersCountChanged");
        }
    };
}




//////////////////
// WEBPACK FOOTER
// ./customer/layout/layout.directive.js
// module id = 791
// module chunks = 0